import * as React from 'react';
import * as intl from 'react-intl-universal';
import { Link } from 'react-router-dom';
import Icon from 'common/components/IconFont';
import { Layout, Menu } from 'antd';
const { Sider } = Layout;
const { SubMenu } = Menu;
import { visualRoutes } from './utils';
import { MetaRoute, Routes } from '../type';
import { Icons } from "./Icons";

interface iConfig {
    roleType: 'Admin' | 'Client' | 'Sales';
    routes: Routes;
    collapsed: boolean;
    onCollapse: any;
    openKeys: string[];
    onOpenChange: any;
    activeKeys: string[];
}

const toggleStyle: React.CSSProperties = {
    position: 'absolute',
    top: '45%',
    right: -13,
    cursor: 'pointer',
    zIndex: 999,
    backgroundColor:'#ddd',
    padding: '8px 0',
};

export default ({ routes, collapsed, onCollapse, openKeys, onOpenChange, activeKeys, roleType }: iConfig) => {
    const explicitRoutes = visualRoutes(routes || []);
    return !!explicitRoutes.length &&
        <Sider className="Launcher-menu-sider" collapsible={true} collapsedWidth={0} collapsed={collapsed} trigger={null}
               onCollapse={onCollapse}>
            <Menu mode="inline" openKeys={openKeys} selectedKeys={activeKeys}>
                {explicitRoutes
                    .map((route: MetaRoute) => {
                        const explicitRoutes = visualRoutes(route.children || []);
                        return explicitRoutes.length
                            ? <SubMenu key={route.key} title={
                                <span title={intl.get(`Menu.${roleType}${route.key}`)}><Icon
                                    className={`anticon-${route.type == 'client' ? (route.icon || Icons[route.key]) : 'point'} ${route.type == 'client' ? 'subMenu-icon' : ''}`}/>{intl.get(`Menu.${roleType}${route.key}`)}</span>
                            } onTitleClick={(event: any) => onOpenChange(event.key)}>
                                {explicitRoutes
                                    .map((route: MetaRoute) => {
                                        return <Menu.Item key={route.key}>
                                            <Link className='ellipsis' title={intl.get(`Menu.${roleType}${route.key}`)}
                                                  to={route.href}>{intl.get(`Menu.${roleType}${route.key}`)}</Link>
                                        </Menu.Item>;
                                    })}
                            </SubMenu>
                            : <Menu.Item key={route.key}>
                                <Link to={route.href}
                                      title={intl.get(`Menu.${roleType}${route.key}`)}>{intl.get(`Menu.${roleType}${route.key}`)}</Link>
                            </Menu.Item>;
                    })}
            </Menu>
            <span style={toggleStyle} onClick={()=>{onCollapse(!collapsed);}}>
                <Icon
                    className={collapsed ? 'anticon-menu-right' : 'anticon-menu-left'}
                    style={{color: '#fff'}}
                />
            </span>
        </Sider>;
};
